import React from 'react';

// MUI
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Divider, Fab } from '@mui/material';

// Icons
import { Close } from '@mui/icons-material';
import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles(theme => ({
  marginTop10: {
    marginTop: 10,
  },
  modalCloseButton: {
    float: 'right',
    marginTop: -6,
  },
  modalTitle: {
    minimumHeight: 50,
  },
}));

const BaseModal = ({ show, onClose, actions, title, message, closeBtnMessage, preventClosing = false }) => {
  const classes = useStyles();

  const handleDialogClose = (event, reason) => {
    if (preventClosing && (reason === 'backdropClick' || reason === 'escapeKeyDown')) {
      return;
    }

    onClose?.(event, reason);
  };

  if (!show) return null;

  return (
    <Dialog
      open={show}
      maxWidth={'lg'}
      fullWidth={true}
      onClose={handleDialogClose}
      disableEscapeKeyDown={preventClosing}
      aria-labelledby="max-width-dialog-title"
      aria-describedby="modal-slide-description">
      <DialogTitle>
        {!preventClosing && (
          <Fab size="small" className={classes.modalCloseButton} key="close" aria-label="Close" onClick={onClose}>
            <Close className={classes.modalClose} />
          </Fab>
        )}
        <h2 className={classes.modalTitle}>{title}</h2>
        <Divider className={classes.marginTop10} />
      </DialogTitle>
      <DialogContent id="modal-slide-description" className={classes.modalBody}>
        <span
          dangerouslySetInnerHTML={{
            __html: message,
          }}
        />
      </DialogContent>
      <DialogActions className={classes.modalFooter}>
        {actions?.map(action => (
          <Button {...action}>{action.message}</Button>
        ))}
        {!preventClosing && (
          <Button onClick={onClose} color="primary">
            {closeBtnMessage}
          </Button>
        )}
      </DialogActions>
    </Dialog>
  );
};
export default BaseModal;
